import { Input, Output, EventEmitter, Component, OnInit, AfterViewInit } from '@angular/core';
import { PaymentsDialogComponent } from 'src/app/modules/accounts/accounts.dialog.payments.component';
import { openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { ConfirmDeleteData } from 'src/app/components/dialog.confirmDelete.component';
import { Wrapper } from '../wrapper.component';
import { JoiAccount } from 'globals/store/accounts.data';
import { uiActions } from 'src/app/store/ui.era';
import { userActions } from 'src/app/store/user.era';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from '../photo';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { IconComponent } from '../icon/icon.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-account-profile-panel',
    templateUrl: './account-profile-panel.html',
    styleUrls: ['./account-profile-panel.component.scss'],
    imports: [CommonModule, MatButtonModule, PhotoComponent, MatMenuModule, MatProgressBarModule, IconComponent],
    standalone: true,
})
export class AccountProfilePanelComponent extends Wrapper<AccountProfilePanelComponent> implements OnInit, AfterViewInit {

  readonly _file = 'account-profile-panel.component.ts';
  suspended
  unplanned_status = ['fresh','trial','suspended'];
  @Input() acc: JoiAccount
  @Input() creating
  @Output() visit: EventEmitter<string> = new EventEmitter();

  ngOnInit() {
    this.subProp(this.store.select('accounts','suspended',this.acc.id), 'suspended')
  }

  async ngAfterViewInit() {
    this.subCallback(this.store.select('user', 'showAccountPlansDialog'), showAccountPlans => {
      // this needed to be in the store so that clicking the link from outside this component would still open the plans popup
      if (showAccountPlans && showAccountPlans === this.acc.id ) {
        this.store.dispatch(userActions.showViewPlans(null))
        setTimeout(_=>{ this.plansPopup(this.acc.id) }, 1000);
      }
    })
  }

  visitAccount(id){
    this.visit.emit(id)
  }

  async removeFromAccount(accountId:string, fromEl:string){
    const el = document.getElementsByClassName(fromEl);
    const rect = el[0].getBoundingClientRect();
    const data: ConfirmDeleteData = { rect, title: 'Leave account', delete_btn_text: 'LEAVE', dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.accountService.removeAccountUser(accountId, this.userService.email,this.userService.uid,{file:this._file,function:'removeFromAccount',error:new Error()})
  }

  plansPopup(accountId){
    this.dialog.open(PaymentsDialogComponent, {
      width:'680px', disableClose: true,
      data: {area:null, the_accountId:accountId}
    })
  }

}
